/* ==========================================================================
   Stat count-up.

   The percentages in the PDP stat card count from half their value to the full
   one over 2s (2.5s on Body Oil V3) when the card scrolls into view.

   Same shape as assets/reveal.js and deliberately so: one document-level
   IntersectionObserver rather than one per element, elements unobserved the
   moment they play, vanilla, no dependency, deferred. Read that file first if
   you are changing this one.

   The markup ships the FINAL value as text. This script only ever animates
   away from it and back to it, so with JS off, an observer missing, reduced
   motion on, or the theme editor open, the number a visitor sees is the number
   the merchant typed. Nothing here is load-bearing for content.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__forchicsStatCountUp) {
    return;
  }
  window.__forchicsStatCountUp = true;

  var SELECTOR = '[data-stat-countup]';
  /* A slightly gentler count on Body Oil V3; retain the existing timing elsewhere. */
  var isBodyOilV3 = /\/products\/body-oil-v3\/?$/.test(window.location.pathname);
  var DURATION_MS = isBodyOilV3 ? 2500 : 2000;

  /* Same ratio trigger as reveal.js, for the same reason: a rootMargin line
     strands anything whose resting position sits below it. */
  var VISIBLE_RATIO = 0.15;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = Boolean(window.Shopify && window.Shopify.designMode);

  /* "97%" -> ['', 97, '%'].  "4.8/5" -> ['', 4.8, '/5'].  Anything without a
     number in it returns null and is left alone. Splitting rather than
     stripping keeps whatever the merchant typed around the digits - a suffix,
     a currency symbol, a trailing slash - instead of guessing at it. */
  function parse(text) {
    var match = String(text).match(/^(\D*?)(\d+(?:[.,]\d+)?)(.*)$/);
    if (!match) {
      return null;
    }
    var raw = match[2];
    var separator = raw.indexOf(',') > -1 ? ',' : '.';
    var decimals = raw.indexOf(separator) > -1 ? raw.length - raw.indexOf(separator) - 1 : 0;
    return {
      prefix: match[1],
      value: parseFloat(raw.replace(',', '.')),
      suffix: match[3],
      decimals: decimals,
      separator: separator
    };
  }

  function format(parts, n) {
    var out = n.toFixed(parts.decimals);
    if (parts.separator === ',') {
      out = out.replace('.', ',');
    }
    return parts.prefix + out + parts.suffix;
  }

  /* Ease-out cubic. A linear count reads mechanical - it arrives at the final
     digit at exactly the speed it left the first one. */
  function ease(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function play(el) {
    var parts = parse(el.getAttribute('data-stat-countup') || el.textContent);
    if (!parts) {
      return;
    }

    /* Pin the width the FINAL value occupies before touching the text. The
       count starts at half, so "50%" is narrower than "100%" and the row would
       shuffle sideways for a second - a layout shift, on a page whose CLS is
       otherwise 0. Measured rather than computed in ch, because the element's
       own letter-spacing and suffix are part of the width.

       This handles a count that GAINS a digit. It cannot handle the box
       growing, which is what proportional digits did: an intermediate 88 is
       wider than a final 94. The stylesheet asks for tabular figures for that,
       so every intermediate is exactly as wide as the final one; the two
       together are what keep the box constant for the whole count. */
    el.style.minWidth = el.getBoundingClientRect().width + 'px';

    var from = parts.value / 2;
    var span = parts.value - from;
    var started = null;

    function frame(now) {
      if (started === null) {
        started = now;
      }
      var t = Math.min((now - started) / DURATION_MS, 1);
      el.textContent = format(parts, from + span * ease(t));
      if (t < 1) {
        window.requestAnimationFrame(frame);
      } else {
        // Land on the merchant's exact string, not a re-formatted copy of it.
        el.textContent = parts.prefix + String(parts.value).replace('.', parts.separator) + parts.suffix;
      }
    }

    el.textContent = format(parts, from);
    window.requestAnimationFrame(frame);
  }

  if (designMode || reduceMotion || !('IntersectionObserver' in window) || !window.requestAnimationFrame) {
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          return;
        }
        var el = entry.target;
        var tall = entry.rootBounds && entry.boundingClientRect.height > entry.rootBounds.height * 0.85;
        if (!tall && entry.intersectionRatio < VISIBLE_RATIO) {
          return;
        }
        observer.unobserve(el);
        el.dataset.statCountupDone = 'true';
        play(el);
      });
    },
    { threshold: [0, VISIBLE_RATIO, 1] }
  );

  function scan(scope) {
    var nodes = (scope || document).querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(nodes, function (el) {
      // Idempotent, so a section reload cannot re-run a number that has played.
      if (el.dataset.statCountupDone === 'true' || el.dataset.statCountupArmed === 'true') {
        return;
      }
      el.dataset.statCountupArmed = 'true';
      observer.observe(el);
    });
  }

  scan(document);

  ['shopify:section:load', 'shopify:section:reorder', 'shopify:block:select'].forEach(function (evt) {
    document.addEventListener(evt, function (event) {
      scan(event.target && event.target.nodeType === 1 ? event.target : document);
    });
  });

  window.ForchicsStatCountUp = { scan: scan };
})();
